import { ModelID } from '@core/shared/ModelID';
import { ContractWithBonus, ContractBonus } from '../../types';
import { HttpGetRequest } from '@infrastructure/axios/http-get-request';

export default class GetContractByIdUseCase extends HttpGetRequest<ContractWithBonus> {
  private getBonusUseCase: GetContractBonusByContractIdUseCase = new GetContractBonusByContractIdUseCase();

  public async execute(contractId: ModelID): Promise<ContractWithBonus> {
    const contractBonus = await this.getBonusUseCase.execute(contractId);
    const contract = (await this.dispatch(`/contracts/${contractId}`)).data;
    return { ...contract, bonus: contractBonus };
  }
}

// T-44 move this to correct place
class GetContractBonusByContractIdUseCase extends HttpGetRequest<ContractBonus[]> {
  public async execute(contractId: ModelID): Promise<ContractBonus[]> {
    return (await this.dispatch(`/contracts/${contractId}/bonus`)).data.data;
  }
}
